import api from "../utils/api";

export const list = ({ direction, status, search, unassociated, size = 20 } = {}) => async () => {
    const params = new URLSearchParams();
    if (direction && direction !== "all") params.append("direction", direction);
    if (status) params.append("status", status);
    if (search) params.append("search", search);
    if (unassociated) params.append("unassociated", "true");
    if (size) params.append("size", String(size));

    const response = await api.get(`/fax${params.toString() ? `?${params.toString()}` : ""}`);
    return response.data || response;
};

export const get = ({ uuid }) => async () => {
    const response = await api.get(`/fax/i/${uuid}`);
    return response.data || response;
};

export const send = (payload) => async () => {
    const response = await api.post("/fax/send", payload);
    return response.data || response;
};

export const refresh = ({ uuid }) => async () => {
    const response = await api.post(`/fax/i/${uuid}/refresh`);
    return response.data || response;
};

export const associate = ({ uuid, personUuid, directoryUuid }) => async () => {
    const response = await api.post(`/fax/i/${uuid}/associate`, {
        personUuid,
        directoryUuid: directoryUuid || null
    });
    return response.data || response;
};
